import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { DateTime } from "luxon";
import { MatDialog, MatPaginator ,PageEvent} from '@angular/material';
import { EventService } from '../event.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { JsplDetailsViewComponent } from '../jspl-details-view/jspl-details-view.component';

@Component({
  selector: 'app-in-plant-vehicles',
  templateUrl: './in-plant-vehicles.component.html',
  styleUrls: ['./in-plant-vehicles.component.scss']
})
export class InPlantVehiclesComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("addRemarkDialog", { static: true }) addRemarkDialog: TemplateRef<any>;
  @ViewChild("showData", { static: true }) showData: TemplateRef<any>;
  selectedRowIndex:any;
  pageEvent: PageEvent;
  showLoader = false;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  displayedColumns = ['sno', 'gate_entry_no', 'vehicle_details', 'plant_ageing', 'customer_details','carrier_details','driver_details', 'od_status', 'desiredweight','material', 'remarks']
  inPlantvehicles: any = [];
  inPlantvehiclesFilter: any= {
    limit: 0,
    skip: 0,
  };
  totalvehicles = 0;
  carrierUpdates: Subscription;
  reasons: any;
  shipperRemark: any;
  attachedDriver: any;
  dialogRef: any;
  showDialogRef: any;
  currentUnit = true;
  rowData:any;
  odNumber;
  vehicleNumber;
  allUnit = true;


  constructor(private http: HttpService, private snackBar: SnackbarService, private events: EventService, private dialog: MatDialog,) { }


  ngOnInit(): void {
    let myCurrentDate = new Date();
    let myPastDate = new Date(myCurrentDate);
    myPastDate.setDate(myPastDate.getDate() - 10);
    this.fromDate = new Date(myPastDate);
    this.toDate = new Date();
    this.getInplantvehicles();
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.getInplantvehicles();
      }
    );
  }

  getInplantvehicles(filter: any = {}) {
    this.showLoader = true;
    this.inPlantvehicles= [];
    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    filter.all = true;
    if(this.currentUnit){
      filter.all = false;
    }
      filter.from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC(),
      filter.to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC(),
      this.http.get('inPlantVehicles/many', filter, 2).subscribe((data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.inPlantvehicles = data.data.records;
          if (this.inPlantvehicles.length && this.inPlantvehicles.remarks && this.inPlantvehicles.remarks.length) this.inPlantvehicles.remarksJoined = this.inPlantvehicles.remarks.shift().join(', ');
          console.log(this.inPlantvehicles)
          this.totalvehicles = data.data.count;
        }
      }, (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      })
  }

  pageNavigate(event: PageEvent) {
    this.inPlantvehiclesFilter.limit = event.pageSize;
    this.inPlantvehiclesFilter.skip = event.pageIndex * event.pageSize;
    this.getInplantvehicles(this.inPlantvehiclesFilter);
  }
  download() {
    console.log("download");
  }
  allUnitData(){
    console.log("all unit");
  }
  getOrderStatus (row,i){
    this.selectedRowIndex= i;
    this.rowData=[];
    this.rowData.push({
      name: 'Vehicle No.',
      value: row.vehicle
    });
    const temp: any = [{
      name: 'SIN',
      value: row.sin
    }, {
      name: 'Customer Name',
      value: row.cust_name
    }, {
      name: 'OD Issued Time',
      value: row.od_issued_time
    }, {
      name: 'Destination',
      value: row.destination
    }, {
      name: 'Distance (KMs)',
      value: row.distance
    }, {
      name: 'Do Status',
      value: row.doStatus
    }, {
      name: 'Driver Type',
      value: row.driver_type
    }, {
      name: 'Gate In No.',
      value: row.entry_no
    }, {
      name: 'Gate In Time',
      value: row.gateintime
    }, {
      name: 'Gross Weight',
      value: row.grossWeight
    }, {
      name: 'Invoice Date',
      value: row.invoiceDate
    }, {
      name: 'Loading Point',
      value: row.loadingPoint
    },{
      name: 'Loading Point Entry',
      value: row.loadingPointEntry
    }, {
      name: 'Loading Point Exit',
      value: row.loadingPointExit
    }, {
      name: 'Per Vehicle Weight (MT)',
      value: row.per_vehicle_weight
    }, {
      name: 'Pickup',
      value: row.pickup
    },
    {
      name: 'Tare Weight',
      value: row.tareWeight
    }];
    this.rowData = [...this.rowData, ...temp];
    this.vehicleNumber= row.vehicle;
    this.odNumber = row.od_status || 'N/A';
    const dialogRef = this.dialog.open(JsplDetailsViewComponent, {
      data: this.rowData,
      width: '1250px',
      maxWidth: '95vw !important'
    });
  }
  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
   }
}
